import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const OpenEye = ({
  size,
  type,
  theme,
  className,
  dataTestId = "open-eye-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M8.00009 10.3961C9.32333 10.3961 10.396 9.32346 10.396 8.00022C10.396 6.67699 9.32333 5.6043 8.00009 5.6043C6.67686 5.6043 5.60417 6.67699 5.60417 8.00022C5.60417 9.32346 6.67686 10.3961 8.00009 10.3961Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4627 7.99951C15.4627 7.75482 15.3665 7.50383 15.2788 7.31435C15.1792 7.09936 15.0395 6.85834 14.8675 6.60576C14.5228 6.09963 14.0249 5.51247 13.3928 4.95312C12.1323 3.83763 10.2828 2.78635 8.00079 2.78659C5.74103 2.78683 3.89518 3.71973 2.62114 4.79326C1.98415 5.33001 1.47873 5.91101 1.12745 6.44771C0.796099 6.95395 0.539062 7.51602 0.539062 7.99951V8.00031C0.539062 8.4838 0.796099 9.04586 1.12745 9.5521C1.47873 10.0888 1.98415 10.6698 2.62114 11.2066C3.89518 12.2801 5.74103 13.213 8.00079 13.2132C10.2828 13.2135 12.1323 12.1622 13.3928 11.0467C14.0249 10.4873 14.5228 9.90018 14.8675 9.39406C15.0395 9.14148 15.1792 8.90046 15.2788 8.68546C15.3665 8.49599 15.4627 8.245 15.4627 8.00031V7.99951ZM8.00093 4.11992C9.85912 4.11973 11.4072 4.97644 12.5092 5.95162C13.0584 6.43761 13.4829 6.94145 13.7654 7.35627C13.907 7.56417 14.0071 7.74111 14.0689 7.8746C14.0963 7.93386 14.1117 7.97492 14.1202 7.99991C14.1117 8.0249 14.0963 8.06596 14.0689 8.12521C14.0071 8.2587 13.907 8.43565 13.7654 8.64354C13.4829 9.05837 13.0584 9.56221 12.5092 10.0482C11.4072 11.0234 9.85912 11.8801 8.00093 11.8799C6.12049 11.8797 4.56877 11.1041 3.4803 10.1869C2.93603 9.72832 2.51896 9.24343 2.24306 8.82191C1.94723 8.36993 1.8724 8.08145 1.8724 8.00031V7.99951C1.8724 7.91837 1.94723 7.62989 2.24306 7.17791C2.51896 6.75639 2.93603 6.2715 3.4803 5.81289C4.56877 4.89572 6.12049 4.12012 8.00093 4.11992Z"
    />
  </SVGIcon>
);
